import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors, FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../services/auth/auth.service";
import { Subscription } from "rxjs/Subscription";

import { NotificationComponent } from "../shared/notification.component";
import { iResponseInfo } from '../../interfaces/shared/iresponseinfo';
import { PasswordValidator } from '../../custom/password-validator';



@Component({
    selector: 'app-change-password',
    templateUrl: './password-change.component.html'
})
export class PasswordChangeComponent implements OnInit, OnDestroy {
    @ViewChild('notification') notificationComponent: NotificationComponent;

    frm: FormGroup;

    constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService, private formBuilder: FormBuilder) { }

    onPasswordChanged: Subscription;
    onPasswordChangedReset: Subscription;
    onFormValueChanged: Subscription;

    isChangePassword: boolean = true;
    resetPwdParam: string = "";
    loading: boolean = false;

    ngOnInit() {
        let prParam = this.route.snapshot.queryParams["pr"];
        if (prParam != undefined) {
            this.isChangePassword = false;
            this.resetPwdParam = prParam;
        }

        this.frm = this.formBuilder.group(
          {
            oldPassword: new FormControl(this.isChangePassword ? null : "xxx", [Validators.required]),
            newPassword: [null, Validators.compose([
                  Validators.required,
                  Validators.minLength(8),
                  PasswordValidator.patternValidator(/\d/, { hasNumber: true }),
                  PasswordValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
                  PasswordValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
                  PasswordValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, { hasSpecialCharacters: true }),
                ])],

            repeatNewPassword: [null, Validators.compose([Validators.required])]

          },
          {
            validator: PasswordValidator.passwordsMatch
          }
        );


        this.onFormValueChanged = this.frm.valueChanges.subscribe(data => { this.notificationComponent.clear(); })

        this.onPasswordChanged = this.authService.passwordChanged
            .subscribe(
            (response: iResponseInfo) => {
                this.notificationComponent.animate(response);

                if (response.isSuccess) {
                    this.onClear();
                }
                this.loading = false;
            });

        this.onPasswordChangedReset = this.authService.passwordChangedReset
            .subscribe(
            (response: iResponseInfo) => {
                this.notificationComponent.animate(response);

                if (response.isSuccess) {
                    this.onClear();
                    setTimeout(() => { this.router.navigate(['/login']); }, 1500)
                }
                this.loading = false;
            });
    }

    ngOnDestroy() {
        this.onPasswordChanged.unsubscribe();
        this.onPasswordChangedReset.unsubscribe();
        this.onFormValueChanged.unsubscribe();
    }

    onChangePassword() {
        this.loading = true;

        const newPassword = this.frm.value.newPassword;
        const repeatNewPassword = this.frm.value.repeatNewPassword;

        if (this.isChangePassword) {
            const oldPassword = this.frm.value.oldPassword;
            this.authService.changePassword(oldPassword, newPassword);
        }
        else {
            this.authService.changeResetPassword(newPassword, this.resetPwdParam);
        }

      this.authService.logout();
      this.router.navigate(['login']);
    }

    onClear() {
        this.frm.value.oldPassword = null;
        this.frm.value.newPassword = null;
        this.frm.value.repeatNewPassword = null;

        this.frm.reset();
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/anon/password-change.component.ts